/**
 * O Chrome **ignora** `autocomplete="off"` no autofill de endereços/contatos —
 * é por isso que o balão com nome, e-mail e "Gerenciar endereços..." continuava
 * abrindo em campos como "Nome Fantasia" mesmo com `off` em todo lugar. O que o
 * Chromium respeita melhor em campos comuns é `one-time-code`: ele impede que
 * o campo seja classificado como endereço, contato ou pagamento. Senhas usam
 * `new-password`, pois esse token bloqueia credenciais já armazenadas.
 */
export const AUTOCOMPLETE_BLOQUEADO = "one-time-code";

/**
 * Campo de senha é a exceção: com token desconhecido o Chrome ainda abre a
 * lista de credenciais salvas, e só `new-password` desliga esse balão.
 * (No caminho normal a senha nem chega aqui como `password` — ver
 * `navegadorMascaraSenhaPorCss` em `components/ui/assistenciaTexto`.)
 */
export function autoCompleteBloqueado(tipo?: string): string {
  return String(tipo || "").toLowerCase() === "password" ? "new-password" : AUTOCOMPLETE_BLOQUEADO;
}
